import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { deliverables } from "../../data/content";
export function DeliverablesSection() {
  return <section className="bg-paper px-4 py-16 md:py-24" data-id="element-156" data-mp="2o05vtjzok833">
      <div className="mx-auto max-w-5xl" data-id="element-157" data-mp="2nxjq7pwco2ni">
        <SectionHeading eyebrow="Here’s what you’ll receive" title="Everything you need in one organized collection" data-id="element-158" data-mp="2j01drpj4j5ar" />
        <div className="mt-10 grid gap-4 md:grid-cols-3 md:gap-6" data-id="element-159" data-mp="1vc09wtww4d1o">
          {deliverables.map(d => <article key={d.title} className="flex flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-line" data-id="element-160" data-mp="1raohkgmmtdps">
              <span className="font-display text-7xl font-black leading-none text-brand" data-id="element-161" data-mp="25233av7xbt0j">{d.figure}</span>
              <h3 className="mt-3 font-display text-xl font-extrabold uppercase leading-tight text-ink" data-id="element-162" data-mp="207yvk9qu3gye">{d.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-muted" data-id="element-163" data-mp="1ci4ne5hgmgkh">{d.text}</p>
              {d.note && <p className="mt-auto pt-4 text-xs italic leading-relaxed text-muted" data-id="element-164" data-mp="17jjtensswt4h">{d.note}</p>}
            </article>)}
        </div>
        <div className="mt-12" data-id="element-165" data-mp="2ooo5jitts184">
          <CtaButton label="Get instant access for $27" sub="One-time payment · No subscription · Digital educational resources" data-id="element-166" data-mp="2onldh7krnsqm" />
        </div>
      </div>
    </section>;
}